import React from "react";
import { observer } from "mobx-react";

import Checkbox from "@material-ui/core/Checkbox";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import locale from "@bonliva-crm/locale";
import { LookupItem } from "./BisnodeLookupStore";

type Props = {
  allChecked: boolean;
  allDisabled: boolean;
  items: LookupItem[];
  onCheck: (item: LookupItem) => void;
  onCheckAll: () => void;
};

@observer
class BisnodeLookupTable extends React.Component<Props> {
  render() {
    const { allChecked, allDisabled, items, onCheck, onCheckAll } = this.props;

    return (
      <Table size="small">
        <TableHead>
          <TableCell padding="checkbox">
            <Checkbox checked={allChecked} disabled={allDisabled} onChange={onCheckAll} />
          </TableCell>
          <TableCell>{locale.Title}</TableCell>
          <TableCell>{locale.CurrentValue}</TableCell>
          <TableCell>{locale.BisnodeValue}</TableCell>
        </TableHead>

        <TableBody>
          {items.map((item) => {
            const disabled = item.currentValue === item.newValue;

            return (
              <TableRow
                key={item.title}
                hover={!disabled}
                onClick={() => !disabled && onCheck(item)}
                style={{ cursor: "pointer" }}
              >
                <TableCell padding="checkbox">
                  <Checkbox checked={item.checked} disabled={disabled} />
                </TableCell>
                <TableCell>{item.title}</TableCell>
                <TableCell>{item.currentValue}</TableCell>
                <TableCell>{item.newValue}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  }
}

export default BisnodeLookupTable;
